import { render, staticRenderFns } from "./StartUp.vue?vue&type=template&id=57d91189&scoped=true&"
import script from "./StartUp.vue?vue&type=script&lang=js&"
export * from "./StartUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d91189",
  null
  
)

export default component.exports